import React from 'react';
import { useNavigate } from 'react-router-dom';
import ChangePasswordPage from './ChangePasswordPage';

const ChangePasswordPageWrapper = () => {
  const navigate = useNavigate();
  return <ChangePasswordPage navigate={navigate} />;
};

export default ChangePasswordPageWrapper;
